export default defineNuxtRouteMiddleware(async to => {
  const nuxtApp = useNuxtApp()
  const headers = useRequestHeaders()
  const { commit } = nuxtApp.$store as any
  try {
    await Promise.all([nuxtApp.$store.dispatch('region/getAllRegion'), nuxtApp.$store.dispatch('currency/getCurrency')])
    const ipAddress = headers['x-forwarded-for']?.split(',').pop() || ''
    commit('SET_USER_IP_ADDRESS', ipAddress)

    if (headers.cookie) {
      const lineSID = (nuxtApp.$cookiz as any).get('Line_SID')

      if (lineSID) {
        commit('SET_FOREGIN_DOMAIN_FROM_LINE', true)
      }
    }

    if (to.query.from === 'tng') {
      commit('SET_FROM_TNG_MINI_PROGRAM', true)
    }
  } catch (err: any) {
    console.error('nuxtServerInit:error', err?.message)
    throw showError({ statusCode: 404, message: 'Post not found', fatal: true })
  }
})
